import { render, staticRenderFns } from "./OnlineShopStyleDesign.vue?vue&type=template&id=8b7ba6a4&scoped=true&"
import script from "./OnlineShopStyleDesign.vue?vue&type=script&lang=js&"
export * from "./OnlineShopStyleDesign.vue?vue&type=script&lang=js&"
import style0 from "./OnlineShopStyleDesign.vue?vue&type=style&index=0&id=8b7ba6a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7ba6a4",
  null
  
)

export default component.exports